/* ============================================================
   La Nuit — track-order.js
   Drives the customer-facing support center on /pages/track-order.

   Responsibilities:
     - Expand a specific case if the URL hash references it (?#case-NNNN)
     - Confirm before submitting "mark as resolved" / case-close intent
     - Show the chosen attachment filename in reply forms
     - Smooth-scroll the timeline into view on first interaction
   ============================================================ */
(function () {
  var section = document.querySelector('[data-track-section]');
  if (!section) return;

  // 1) Deep-link a specific case from the hash (#case-123)
  function openCaseFromHash() {
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (!hash) return;
    var m = hash.match(/case-(\d+)/);
    if (!m) return;
    var id = m[1];
    var cases = section.querySelectorAll('[data-case]');
    cases.forEach(function (el) {
      var caseId = (el.getAttribute('data-case-id') || '').split('/').pop();
      var details = el.querySelector('details');
      if (details) details.open = (caseId === id);
    });
    var target = Array.prototype.find.call(cases, function (el) {
      return (el.getAttribute('data-case-id') || '').split('/').pop() === id;
    });
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  openCaseFromHash();
  window.addEventListener('hashchange', openCaseFromHash);

  // 2) Confirm close-case button before submit
  section.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('button[name="contact[request_close]"]');
    if (!closeBtn) return;
    if (!window.confirm('Mark this case as resolved? You can still reply to reopen if needed.')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // 3) Show chosen attachment filename in each reply form
  section.querySelectorAll('input[type="file"][name="contact[attachment]"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var f = input.files && input.files[0];
      if (!f) return;
      var label = input.closest('label');
      if (!label) return;
      var hint = label.querySelector('.button--ghost');
      if (hint) hint.textContent = '📎 ' + f.name + ' (' + Math.round(f.size / 1024) + ' KB)';
    });
  });

  // 4) When form posts successfully, scroll the success banner into view
  var success = section.querySelector('.main-track__form-success');
  if (success) success.scrollIntoView({ behavior: 'smooth', block: 'center' });
})();
